import React from "react";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

export const LightBox = ({ children }) => (
  <SimpleReactLightbox>
    <SRLWrapper>{children}</SRLWrapper>
  </SimpleReactLightbox>
);
